import { useEffect, useState } from 'react';
import { getMatchingBreakpoint } from '../../breakpoints';
function getIsMobile() {
    if (typeof window === 'undefined') {
        // assume desktop in server-rendering
        return false;
    }
    return getMatchingBreakpoint(window.innerWidth, ['xs']) !== 'xs';
}
export function useMobile() {
    var _a = useState(function () { return getIsMobile(); }), isMobile = _a[0], setMobile = _a[1];
    function handleResize() {
        setMobile(getIsMobile());
    }
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return isMobile;
}
//# sourceMappingURL=index.js.map